import type { StateStorage } from "zustand/middleware";
import { getStorage } from "@/lib/storage";

export const createCustomStorage = (): StateStorage => {
	return {
		getItem: async (name) => {
			const storage = await getStorage();
			return storage.getItem(name);
		},
		setItem: async (name, value) => {
			const storage = await getStorage();
			storage.setItem(name, value);
		},
		removeItem: async (name) => {
			const storage = await getStorage();
			storage.removeItem(name);
		},
	};
};
